// Components==============
import React from 'react';
import './PreviewToken.module.scss';
// =========================

export default function PreviewToken({
  token,
}: {
  token: { thumbnail: string };
}) {
  return (
    <div styleName="token-wrapper">
      <img
        src={`${token?.thumbnail}`}
        alt={token?.thumbnail}
        styleName="token-image"
      />
    </div>
  );
}
